import { ComponentsState } from 'piral-core';
import { LayoutDefault } from './layouts/LayoutDefault';

export const layout: Partial<ComponentsState> = {
  Layout: LayoutDefault,
};
